// extracted by mini-css-extract-plugin
export default {"status":"VoE0faUTOR1N7j1Q8RNX"};